import React, { Fragment, useEffect, useState } from "react";
import MyCropper from "../../tools/MyCropper";
import { globalFileServer } from "../../../../axiosInstance";
import showAlert from "../../../server/ShowAlert";
import { setPreload } from "../../../server/CartsOpen";
import { useDispatch, useSelector } from "react-redux";
import { updateProductFields } from "../../../server/Product";
import MyCropperComp from "../../tools/MyCrooperComp";
import {
  UploadImageData,
  deleteImageFromServer,
} from "../../../server/UploadImage";
import { showAlertWithConfirmCancel } from "../../../server/ShowAlert";

const ProductEditImg = () => {
  const { product, stationId } = useSelector((state) => ({
    product: state.selectedProduct.product,
    stationId: state.user.stationId,
  }));

  const [imagesList, setImagesList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (product?.media?.length) {
      setImagesList(product.media);
    }
  }, [product]);

  const deleteImage = (image) => {
    showAlertWithConfirmCancel({
      msgTitle: "האם אתה בטוח שברצונך למחוק את התמונה?",
      confirmText: "מחק",
      cancelText: "ביטול",
      onConfirm: () => {
        dispatch(setPreload(true));
        const newMedia = [...product.media.slice(0, image), ...product.media.slice(image+1)];
        updateProductFields(stationId, product.productId, { "media": newMedia })
          .then(() => {
            setImagesList(newMedia);
            showAlert({ msgTitle: "התמונה נמחקה", msgType: "success" });
          })
          .catch(() =>
            showAlert({ msgTitle: "שגיאה במחיקה", msgType: "error" }),
          )
          .finally(() => dispatch(setPreload(false)));
      },
    });
  };

  const uploadImg = (data) => {
    setImagesList((prev) => [...prev, data]);
    dispatch(setPreload(false));
  };

  return product ? (
    <Fragment>
      <div className="flex">
        <MyCropper
          uploadImg={uploadImg}
          itemId={product.productId}
          folder="products"
          beforeFileName={`${product.mkt}_${product.gtin}_`}
        />
      </div>

      {imagesList.length ? (
        <div className="img-list">
          {imagesList.map((img, index) => (
            <div key={index} className="img-container">
              {!img.path?.includes(".zip") && (
                <>
                  <img
                    className="img"
                    src={globalFileServer + "products/" + img.path}
                    alt=""
                  />

                  <img
                    className="delete"
                    src={
                      globalFileServer + "iconcss/deleteLocationAndListI.svg"
                    }
                    alt="מחק"
                    onClick={() => deleteImage(index)}
                  />

                  <div className="image-details">
                    {img.width && img.height && (
                      <label>
                        <strong>רזולוציה:</strong> {img.width} × {img.height}
                      </label>
                    )}
                    <label>
                      <strong>מקור:</strong> GS1
                    </label>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div>אין תמונות להצגה</div>
      )}
    </Fragment>
  ) : null;
};

export default ProductEditImg;
